import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const sold = ({ sold: _sold }: VehicleStatsByCompany): string =>
    _sold && Number.isFinite(_sold) ? `${_sold}` : '--'
